// Note: No register.ts helper — V1 backward compatibility is not needed for upto.
// Use direct class instantiation: server.register("eip155:*", new UptoEvmScheme())
export { UptoEvmScheme } from "./scheme";
